import Account from 'components/shared/Account/Account'
import PropTypes from 'prop-types'
import React from 'react'

import NavContainer from './Nav/NavContainer'
import PrintButton from './PrintButton/PrintButton'
import './Sidebar.css'

const Sidebar = ({ locale, slug, user }) => {
  return (
    <menu className="c-sidebar">
      <NavContainer />
      <PrintButton locale={locale} slug={slug} />
      {!user && <Account locale={locale} />}
    </menu>
  )
}

Sidebar.propTypes = {
  locale: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  user: PropTypes.object,
}

export default Sidebar
